// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';
import { connect } from 'react-redux';

import { getData } from '../store/selectors';
import * as globalActions from '../../../store/globalStore/actions';
import * as packGuidelinesActions from '../store/actions';
import { Helper } from '../components';
import Navigation from '../../../common/Navigation/Navigation';
import styles from './styles';

class PackagingGuidelinesPage extends React.Component {
  state = {};

  componentDidMount() {
    this.props.setPage({ current_page: 'Packaging guidelines' });
    this.props.requestPageData();
  }

  componentWillUnmount() {
    this.props.setPage({ current_page: null });
  }

  render() {
    const { classes, data } = this.props;
    return (
      <Navigation isPG mobileLikeIndex={false}>
        <div className={classes.mainContainer}>
          <div className={classes.subContainer}>
            <h4 className={classes.title}>{data.title}</h4>
            <div className={classes.imageTitleContainer}>
              <img className={classes.image} src={data.mainImage} alt={'main'} />
              <span className={classes.mainText}>{data.description}</span>
            </div>
            <div className={classes.helpersContainer}>
              {data.imagesWithDescription.map((el, i) => (
                <Helper key={uuidv4()} {...el} reverse={i % 2 !== 0} />))}
            </div>
          </div>
        </div>
      </Navigation>
    );
  }
}

PackagingGuidelinesPage.propTypes = {
  classes: PropTypes.object,
  setPage: PropTypes.func,
  requestPageData: PropTypes.func,
  data: PropTypes.object,
};

PackagingGuidelinesPage.defaultProps = {
  classes: {},
  setPage: () => { },
  requestPageData: () => { },
  data: {
    imagesWithDescription: [],
  },
};

const mapStateToProps = (state) => {
  return {
    data: getData(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: page => dispatch(globalActions.setPage(page)),
    requestPageData: () => dispatch(packGuidelinesActions.requestPageData()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PackagingGuidelinesPage));
